var map = {
	"./avia/airarabia.svg": "475d",
	"./avia/bees.svg": "261e",
	"./avia/flydubai.svg": "cd62",
	"./avia/intro-car-logo-A3.svg": "c280",
	"./avia/intro-car-logo-A9.svg": "f40a",
	"./avia/intro-car-logo-AA.svg": "db54",
	"./avia/intro-car-logo-AF.svg": "741a",
	"./avia/intro-car-logo-AY.svg": "6d0a",
	"./avia/intro-car-logo-BA.svg": "dcb7",
	"./avia/intro-car-logo-CSA.svg": "1e0a",
	"./avia/intro-car-logo-DY.svg": "7580",
	"./avia/intro-car-logo-EK.svg": "3d4e",
	"./avia/intro-car-logo-IB.svg": "d1f0",
	"./avia/intro-car-logo-KL.svg": "990f",
	"./avia/intro-car-logo-LH.svg": "85de",
	"./avia/intro-car-logo-LX.svg": "e685",
	"./avia/intro-car-logo-OA.svg": "f680",
	"./avia/intro-car-logo-OS.svg": "94f9",
	"./avia/intro-car-logo-QR.svg": "e22a",
	"./avia/intro-car-logo-QS.svg": "6187",
	"./avia/intro-car-logo-RM.svg": "cb62",
	"./avia/intro-car-logo-SN.svg": "1568",
	"./avia/intro-car-logo-SQ.svg": "0e86",
	"./avia/intro-car-logo-UA.svg": "237b",
	"./avia/intro-car-logo-VK.svg": "104d",
	"./avia/intro-car-logo-VY.svg": "c23f",
	"./avia/intro-car-logo-eva.svg": "d655",
	"./avia/intro-car-logo-xUIA.svg": "85b7",
	"./avia/ryanair.svg": "700b",
	"./avia/skyup.svg": "4952",
	"./avia/windrose.svg": "6496",
	"./avia/wizz.svg": "1698",
	"./hotel/AMR.svg": "48fd",
	"./hotel/anantara.svg": "2552",
	"./hotel/angsana.svg": "9450",
	"./hotel/banyantree.svg": "7007",
	"./hotel/fourseasons.svg": "602c",
	"./hotel/h10hotels.svg": "3abc",
	"./hotel/hilton.svg": "1282",
	"./hotel/hyatt.svg": "038e7",
	"./hotel/iberostar.svg": "4c0a",
	"./hotel/ihg.svg": "4e17",
	"./hotel/lhw.svg": "6799",
	"./hotel/majestic-resorts.svg": "55f4",
	"./hotel/marriott.svg": "d7a6",
	"./hotel/melia.svg": "57aa",
	"./hotel/oneandonlyresorts.svg": "6d8e",
	"./hotel/palladiumhotelgroup.svg": "b777",
	"./hotel/riu.svg": "9fea",
	"./hotel/sandals.svg": "5168",
	"./hotel/slh.svg": "12e6",
	"./hotel/theexcellencecollection.svg": "ee15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1216";